import { CheckOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React, { useEffect, useState, useRef } from 'react';

const BaseModal = ({ className, children, footer, title, visible, onHide, onClick, disabled, width, hideText, type, confirmText, loading }) => {
  const [pending, setPending] = useState(false);
  const pendingRef = useRef(false);

  useEffect(() => {
    if (visible) {
      pendingRef.current = false;
      setPending(false);
    }
  }, [visible]);

  // Keep the confirm button loading while the modal is closing; only release the lock (allow a retry) if the modal stays open
  useEffect(() => {
    if (loading) {
      pendingRef.current = true;
      setPending(true);
    } else if (visible && pending) {
      pendingRef.current = false;
      setPending(false);
    }
  }, [visible, pending, loading]);

  const onHideClick = (event) => {
    event.stopPropagation();
    pendingRef.current = false;
    setPending(false);
    onHide();
  };

  const onConfirmClick = (event) => {
    event.stopPropagation();
    if (!visible || pendingRef.current || loading) return;
    pendingRef.current = true;
    setPending(true);
    onClick();
  };

  return (
    <Modal
      className={className}
      title={title}
      open={visible}
      width={width}
      footer={footer || [
        <div className="modal-buttons">
          <Button type="text" onClick={onHideClick}>{hideText || 'Annuler'}</Button>
          <Button
            onClick={onConfirmClick}
            type={type || 'primary'}
            disabled={disabled}
            icon={<CheckOutlined />}
            loading={pending || loading}
          >
            {confirmText || 'Confirmer'}
          </Button>
        </div>
      ]}
      centered
      closable={false}
      destroyOnClose
      maskClosable={false}
      keyboard={false}
    >
      {children}
    </Modal>
  );
};

export default BaseModal;